import React from "react";

const AnimatedText = ({ text, className, startDelay = 0 }) => {
  const words = text.split(" ");
  return (
    <div className={className}>
      {words.map((word, index) => (
        <span
          key={index}
          style={{
            animationDelay: `${startDelay + index * 0.15}s`,
          }}
        >
          {word}&nbsp;
        </span>
      ))}
    </div>
  );
};

export default AnimatedText;
